import { fromJS } from 'immutable'
import { createSelector } from 'reselect'

export const makeSelectBlock = () =>
  createSelector([makeSelectSharedBlock, makeSelectSharedBlocks], (blockFilter, blocks) => blockFilter(blocks))

const makeSelectSharedBlocks = (state) => state.get('sharedBlocks') || fromJS({})

const makeSelectSharedBlock = (state, props) => (sharedBlocks) => sharedBlocks && sharedBlocks.get(props.name)
